export default __webpack_public_path__ + "static/media/q3_step2.49dee334.png";